// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type EmailAddressWrapper from '../contract/EmailAddressWrapper';

export default function emailAddressWrapper(data: EmailAddressWrapper): EmailAddressWrapper {
    const result: EmailAddressWrapper = {
        __type: 'EmailAddressWrapper:#Exchange',
        ...data,
    };

    return result;
}
